
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h2>Chess Competition </h2>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm rapid-chess-tournament section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Lokmat Chess <span>Competition</span></h2>
            <p>District Level Rapid Chess tournament 2021 Powered by G H Raisoni
                Sport & Cultural Froundation</p>
        </div>

        <div class="row text-justify">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>LOKMAT CHESS COMPETITION</h4>
                </div>
                <div class="fide-chess-text">
                    <p>To mark the Golden Jubilee of Nagpur edition of
                        Lokmat</p>
                </div>

                <p>District Level Rapid Chess tournament 2021 Powered by G H
                    Raisoni Sport & Cultural Froundation</p>
                <h5 class="fw-bold">Date : <span> 18<sup>th</sup>-
                        19<sup>th</sup> December 2021 </span> </h5>
                <h6 class="fw-bold">Venue :</h6>
                <address>
                    Dr. Ambedkar College of Sport Academy (DACSA) Hall,
                    Deekshabhoomi, Nagpur
                </address>
                <h6 class="fw-bold">Timing : </h6>
                <p>
                    Inauguration at 5pm on Saturday
                </p>
            </div>

            <div class="col-md-4">
                <div class="image-effect-2">
                    <h6 class="fw-bold text-center">Rapid Chess Tournament</h6>
                    <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapidchess.webp"
                        alt
                        class="w-100">
                    <!-- <a href="javascript:void(0);" class="btn button--effect-1 w-100"><span>
                        View Results</span> <span class="icon-right-arrow"></span>
                    </a> -->
                </div>
            </div>
        </div>

        <div class="row row-cols-1 row-cols-md-2">
            <div class="gall-ery">
                <div class="row">
                    <div class="col-md-8">
                        <div
                            class="widget_title inner-title gall-sys shadow-text-sm">
                            <h4>PHOTOS</h4>
                        </div>
                    </div>

                    <div class="col-md-4 text-end">
                        <a href="photogallery" class="cmn-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul
                        class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-1.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-1.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="assets\images\events\fidechess-gallery/chess-2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-2.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-2.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-3.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-3.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-4.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-4.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-5.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-5.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-6.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-6.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-7.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-7.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-8.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-8.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-8.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-9.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-9.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-9.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-10.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-10.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-10.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-11.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-11.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-11.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-12.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-12.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/chess-12.webp"
                                    alt="GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</section>
